import React, { useReducer, useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, Send, CheckCircle, AlertCircle, Building, Users, Award, Globe, FileText, CheckSquare } from 'lucide-react';
import { SectionTitle, Row, Col, FormField, Textarea, Input } from '../../../SharedInputs';

// Section Components
export function SectionCompanyDetails({ state, dispatch, errors }) {
  const updateField = (field, value) => {
    dispatch({ type: 'UPDATE_FIELD', section: 'companyDetails', field, value });
  };

  return (
    <div>
      <SectionTitle icon={Building}>Company Details</SectionTitle>
      
      <Row>
        <Col span={12}>
          <FormField label="Company Name (Legal Name)" required error={errors.find(e => e.includes('Company name'))}>
            <Input
              value={state.companyDetails.companyName}
              onChange={(e) => updateField('companyName', e.target.value)}
              placeholder="Enter legal company name"
            />
          </FormField>
        </Col>
      </Row>

      <Row>
        <Col span={6}>
          <FormField label="Trading Name (if different)">
            <Input
              value={state.companyDetails.tradingName}
              onChange={(e) => updateField('tradingName', e.target.value)}
              placeholder="Enter trading name"
            />
          </FormField>
        </Col>
        <Col span={3}>
          <FormField label="ACN">
            <Input
              value={state.companyDetails.acn}
              onChange={(e) => updateField('acn', e.target.value)}
              placeholder="ACN"
            />
          </FormField>
        </Col>
        <Col span={3}>
          <FormField label="ABN" required error={errors.find(e => e.includes('ABN'))}>
            <Input
              value={state.companyDetails.abn}
              onChange={(e) => updateField('abn', e.target.value)}
              placeholder="ABN"
            />
          </FormField>
        </Col>
      </Row>

      <Row>
        <Col span={12}>
          <FormField label="Business Address" required error={errors.find(e => e.includes('Address'))}>
            <Input
              value={state.companyDetails.address}
              onChange={(e) => updateField('address', e.target.value)}
              placeholder="Full business address"
            />
          </FormField>
        </Col>
      </Row>

      <Row>
        <Col span={6}>
          <FormField label="Website Address">
            <Input
              type="url"
              value={state.companyDetails.website}
              onChange={(e) => updateField('website', e.target.value)}
              placeholder="https://www.example.com"
            />
          </FormField>
        </Col>
        <Col span={3}>
          <FormField label="Phone Number" required error={errors.find(e => e.includes('Phone'))}>
            <Input
              type="tel"
              value={state.companyDetails.phone}
              onChange={(e) => updateField('phone', e.target.value)}
              placeholder="+61 X XXXX XXXX"
            />
          </FormField>
        </Col>
        <Col span={3}>
          <FormField label="Email Address" required error={errors.find(e => e.includes('Email'))}>
            <Input
              type="email"
              value={state.companyDetails.email}
              onChange={(e) => updateField('email', e.target.value)}
              placeholder="contact@example.com"
            />
          </FormField>
        </Col>
      </Row>
    </div>
  );
}